(function () {
  'use strict';
// passive tracking
  angular.module('eclipseApp.user')
    .service('passiveTracking', ['$rootScope', '$state','uteEndpoint', '$http', function ($rootScope, $state, uteEndpoint, $http) {
      var trackedStates = $state.get().filter(function (state) {
         return state.hasOwnProperty('trackViews') && state.trackViews === true;
      }).map(function (state){
         return state['name'];
      }),
        internetAccount;

      // by default passive tracking will post a page parameter with value set to the state's fully-qualified name
      // this can be overridden by entering a corresponding value below for the desired state
      var stateMap = {
        'myAccount.viewInvoice': 'myAccount.billingAndPayments'
      };

      function getInternetAccount() {
        if (!$rootScope.userInfo.accounts || $rootScope.userInfo.accounts.length === 0) {
          return;
        }

        if (internetAccount) {
          return internetAccount;
        }

        internetAccount = $rootScope.userInfo.accounts.filter(function (a){
          return a.serviceName === 'Internet/TV'
        })[0];

        return internetAccount;
      }

      function hasInternetAccount() {
        return !!getInternetAccount();
      }

      this.init = function () {
        var self = this;
        $rootScope.$on('$stateChangeSuccess', function (from, to) {
          self.checkPage(to);
        });
      };

      this.checkPage = function (state) {
        state = state || $state.current;
        if (trackedStates.indexOf(state.name) === -1) {
          return;
        }

        // check if the tracked url is already reported
        if($rootScope.passiveTracking && $rootScope.passiveTracking[state.name]) {
          return;
        }

        // passive tracking applies only to users with internet accounts
        if (!hasInternetAccount()){
          return;
        }

        $rootScope.passiveTracking[state.name] = true;
        // post to endpoint...

        $http({
          url: uteEndpoint('v3/logActivity'),
          method:  'POST',
          data: {
            page: stateMap[state.name] || state.name,
            accountNumber: getInternetAccount().accountNumber
          }
        });

      };

    }]);
}());
